import { Component, Prop, Vue, Mixins, Watch } from 'vue-property-decorator';
import store from "Store/index"
import { mixins } from 'vue-class-component';
import UserMixin from 'Mixins/UserMixin';
import BaseComponent from 'Components/Base/ABaseComponent';
import { OrderingListPendingProductRequestViewModel } from 'Api/CoreApi';
import ApiFactory from 'Api/ApiFactory';
import OrderingListUserMixin from 'Mixins/OrderingListUserMixin';

@Component({
    template: "#ordering-list-request-product-overview-template"
})
export default class OrderingListRequestProductOverviewComponent extends mixins(BaseComponent,OrderingListUserMixin) {
    
    
    async created() {
        
        if(!this.isAdvancedAdmin) return;
        this.setLoading();
        await store.dispatch.orderingListRequestProduct.load({withUserInfo : true});
        this.setLoaded();
    }
    
    get  list(){
        return store.state.orderingListRequestProduct.list;
    }
    
    
}

Vue.component('ordering-list-request-product-overview', OrderingListRequestProductOverviewComponent);